import { AnalyticService } from '@application/analytic/analytic.service';
import { Button, ButtonProps } from '@cellula/react';
import { useService } from '@visiba/instantiation';
import type { ReactNode } from 'react';
import { useAnalyticContext } from './analytic_link.provider';

type Props = {
	action: string;
	children?: ReactNode | ReactNode[] | null;
} & ButtonProps<'button'>;

export function AnalyticButton({ action, children, onClick, ...rest }: Props): JSX.Element {
	const analytic = useService(AnalyticService);
	const category = useAnalyticContext();

	function handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
		analytic.trackEvent(category, action);

		if (onClick != null) onClick(event);
	}

	return (
		<Button onClick={handleClick} {...rest}>
			{children}
		</Button>
	);
}
